import { ErrorHandler, NgModule } from '@angular/core';
import { GlobalErrorHandler } from '../interceptor/global-error-handler';
import { ErrorService } from '../service/error-service';

@NgModule({
  imports: [],
  declarations: [],
  providers: [
    ErrorService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    }
  ]
})
export class ErrorModule { }
